export default class AuthModel {
  constructor({ token, userId, level }) {
    this.token = token;
    this.userId = userId;
    this.level = level;
  }
}
